import { userLoaded, loadUser } from "./user";

import { store } from "../store";

const logOut = () => {
  store.dispatch({
    type: "SET_TOKEN",
    data: null,
  })
  window.location = "/login";
};

export const PRELOAD_STARTED = "PRELOAD_STARTED";
export const PRELOAD_FINISHED = "PRELOAD_FINISHED";
export const PRELOAD_ERRORED = "PRELOAD_ERROR";

export const preloadStarted = () => {
  return {
    type: PRELOAD_STARTED
  };
};

export const preloadFinished = () => {
  return {
    type: PRELOAD_FINISHED
  };
};

export const preloadErrored = error => {
  return {
    type: PRELOAD_ERRORED,
    payload: error
  };
};

const preloadInitialState = {
  status: "unloaded",
  error: false
};

export const preloadReducer = (state = preloadInitialState, action) => {
  switch (action.type) {
    case PRELOAD_STARTED:
      return {
        status: "loading",
        error: false
      };
    case PRELOAD_FINISHED:
      return {
        status: "finished",
        error: false
      };
    case PRELOAD_ERRORED:
      return {
        status: "error",
        error: action.payload
      };
    default:
      return state;
  }
};

export const isPreloading = state => {
  return (
    state.preload.status === "unloaded" || state.preload.status === "loading"
  );
};

export const getPreloadError = state => state.preload.error;

export const preloadApp = () => {
  return dispatch => {
    dispatch(preloadStarted());
    loadUser()
      .then(user => {
        dispatch(userLoaded(user));
        dispatch(preloadFinished());
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          logOut()
        } else {
          dispatch(preloadErrored(error));
        }
      });
  };
};



// WEBPACK FOOTER //
// ./frontend/src/actions/preload.js